import {reisy} from 'reisy';

export const style = reisy`
@namespace Grid;

/* 
NOTE: only layout related styles here
*/

contentMaxWidth: 1000px;
contentLgMaxWidth: 1250px;
mobileLayout: auto;
/*
	auto (default): if first item is a secondary or primary make its image full width with text underneath and subsequent items as tiles with text on right.
	tile: always tile images with text on right.
	keep: tries to interfere as little as possible.
*/

padSm: .5em;
pad: .75em;
padLg: 1.5em;

itemCol1: 8.33%;
itemCol2: 16.66%;
itemCol3: 25%;
itemCol4: 33.33%;
itemCol5: 41.66%;
itemCol6: 50%;
itemCol7: 58.33%;
itemCol8: 66.66%;
itemCol9: 75%;
itemCol10: 83.33%;
itemCol11: 91.66%;
itemCol12: 100%;

autoMobileLayout {}
keepMobileLayout {}
tileMobileLayout {}

containerCommon {
	max-width: 500px;
	margin: 0 auto;
	padding: 3em 0;

	$Media.smallest {
		max-width: 400px;
	}

	$Media.small {
		max-width: 600px;
		padding: 3em $pad;
	}

	$Media.medium {
		max-width: $contentMaxWidth;
		padding: 3em $padLg;
	}

	$Media.larger {
		max-width: $contentLgMaxWidth;
	}
}

container {
	@extends containerCommon;
	display: flex;
	flex-wrap: wrap;
	position: relative;
}

itemCommon {
	display: flex;
	box-sizing: border-box;
	margin-bottom: 3em;

	$Media.medium {
		margin-bottom: 1.5em;
	}
}

itemPad {
	padding: 0 $padSm;

	$Media.medium {
		padding: 0 $pad;
	}
}

itemInfoPad {
	padding-left: $pad;
	padding-top: 0;

	$Media.medium {
		padding-top: $pad;
		padding-left: 0;
	}
}

item {
	@extends itemCommon;
	@extends itemPad;
	flex-direction: row;
	width: $itemCol12;

	$Media.medium {
		flex-direction: column;
		width: $itemCol3;
	}
}

itemImgWrap {
	flex-shrink: 0;
	width: 40%;

	$Media.medium {
		width: auto;
	}
}

itemImgAspect {
	position: relative;
}

itemInfo {
	@extends itemInfoPad;
	min-width: 0;

	$Media.smaller {
		padding: 0 0 0 1em;
	}
}

itemTertiary {
	$Media.medium {
		width: $itemCol4;
	}
}

itemTertiaryImgAspect {

}

itemPrimaryCommon {
	@extends item;

	$tileMobileLayout & {
		$Media.smaller {
			flex-direction: row;
			margin-bottom: 2em;
		}
	}
}

itemPrimary {
	@extends item;
	@extends itemPad;
	flex-direction: row;
	width: $itemCol12;

	$keepMobileLayout & {
		$Media.ltMedium {
			flex-direction: column;
		}
	}

	$autoMobileLayout & {
		&:first-child {
			$Media.ltMedium {
				flex-direction: column;
			}
		}
	}
}

itemPrimaryImgWrap {
	@extends itemImgWrap;
	flex: 0 0 auto;
	padding: 0;

	$keepMobileLayout & {
		$Media.ltMedium {
			width: 100%;
		}
	}

	$autoMobileLayout $itemPrimary:first-child & {
		$Media.ltMedium {
			width: 100%;
		}
	}

	$Media.medium {
		box-sizing: border-box;
		width: $itemCol8;
		padding-right: $padSm;
	}
}

itemPrimaryInfoWrap {
	@extends itemInfoPad;
	min-width: 0;
	box-sizing: border-box;

	$keepMobileLayout & {
		$Media.ltMedium {
			padding: $padSm 0 $padSm;
		}
	}

	$autoMobileLayout $itemPrimary:first-child & {
		$Media.ltMedium {
			padding: $padSm 0 $padSm;
		}
	}

	$Media.medium {
		padding: 0 $pad;
	}
}

itemPrimaryImgAspect {
	position: relative;
	padding-top: 100%;

	$keepMobileLayout & {
		$Media.ltMedium {
			padding-top: calc(50% - ($padSm));
		}
	}

	$autoMobileLayout $itemPrimary:first-child & {
		padding-top: calc(50% - ($padSm));
	}

	$Media.medium {
		padding-top: calc(50% - ($padSm));
	}
}

itemSecondary {
	@extends itemPrimaryCommon;
	width: $itemCol12;
	flex-direction: column;

	$tileMobileLayout & {
		$Media.ltMedium {
			flex-direction: row;
		}
	}

	$autoMobileLayout & {
		$Media.ltMedium {
			flex-direction: row;
			&:first-child {
				flex-direction: column;
			}
		}
	}

	$Media.medium {
		width: $itemCol8;
	}
}

itemSecondaryImgWrap {
	/*@extends itemImgWrap;*/

	width: 100%;

	$tileMobileLayout & {
		$Media.ltMedium {
			flex-shrink: 0;
			width: 40%;
		}
	}

	$autoMobileLayout & {
		$Media.ltMedium {
			flex-shrink: 0;
			width: 40%;
		}
	}
	
	$autoMobileLayout $itemSecondary:first-child & {
		box-sizing: border-box;
		width: $itemCol12;
		flex: 0 0 auto;
	}
}

itemSecondaryInfoWrap {
	@extends itemInfoPad;
	box-sizing: border-box;

	$keepMobileLayout & {
		padding: $padSm 0 $padSm;
	}

	$autoMobileLayout $itemSecondary:first-child & {
		$Media.ltMedium {
			padding: $padSm 0 $padSm;
		}
	}
}

itemSecondaryImgAspect {
	position: relative;
	padding-top: calc(50% - ($padLg * .5));

	$tileMobileLayout & {
		$Media.ltMedium {
			padding-top: 100%;
		}
	}

	$autoMobileLayout & {
		$Media.ltMedium {
			padding-top: 100%;
		}
	}

	$autoMobileLayout $itemSecondary:first-child & {
		padding-top: calc(50% - ($padLg * .5));
	}
}
`;



// WEBPACK FOOTER //
// ./lib/styling/grid.js